export default __webpack_public_path__ + "static/shawn-ff281ff5949cb904780b916bcb157eb2.png";